"use client";

import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { useRouter } from "@/i18n/routing";
import { io, Socket } from "socket.io-client";
import { GetUserDetailAction } from "@/lib/actions";
import { useSetAtom } from "jotai";
import { inSessionAtom } from "../_store";

type SocketIOContextType = {
  checkSession: () => boolean;
};

const SocketIOContext = createContext<SocketIOContextType | null>(null);

const SocketIOProvider = ({ children, accessToken: token }: { readonly children: ReactNode; accessToken?: string }) => {
  const router = useRouter();
  const setSession = useSetAtom(inSessionAtom);
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_SOCKETIO_DISABLE === "true") {
      return;
    }
    let socket: Socket;
    if (token) {
      GetUserDetailAction().then((data) => {
        socket = io(process.env.NODE_ENV === "production" ? "/" : "http://localhost:5544", {
          auth: { token, role: "player", username: data.user_information.username },
        });

        socket.on("update-session", (hasSession?: boolean) => {
          if (hasSession) setSession(hasSession);
          if (hasSession) {
            localStorage.setItem("in-session", "true");
          } else {
            localStorage.removeItem("in-session");
          }
        });

        socket.on("in-session", () => {
          console.log("in-session");
          localStorage.setItem("in-session", "true");
          setSession(true);
        });

        socket.on("in-session-closed", () => {
          console.log("in-session-closed");
          localStorage.removeItem("in-session");
          setSession(false);
          router.refresh();
        });
      });
    }
    return () => {
      socket?.disconnect();
    };
  }, [token]);
  const checkSession = () => {
    return false;
  };
  return <SocketIOContext.Provider value={{ checkSession }}>{children}</SocketIOContext.Provider>;
};

const useSocketIO = () => {
  const context = useContext(SocketIOContext);
  if (!context) {
    throw new Error("useSocketIO must be used within a SocketIOProvider");
  }
  return context;
};

export { useSocketIO, SocketIOProvider };
